import {ClasesCampoLayoutCamposPorcentajeFormularioEnum, IFormInput} from '@appNeo/neoShared/helpers/interfaces/IForm-input';
import {FormTagEnum} from '@appNeo/neoShared/helpers/enums/FormTag.enum';

export const INPUTSMAINCTA: IFormInput[] = [
  {
    tag: FormTagEnum.input,
    label: 'Nombre y apellidos',
    type: 'text',
    placeholder: 'Nombre y apellidos',
    formControlName: 'nombre',
    obligatorio: true,
    responsivo: true,
    validadores: [],
    clasePersonalizadaLayoutCamposPorcentaje: [ClasesCampoLayoutCamposPorcentajeFormularioEnum.campoPorcent6x],
  },
  {
    tag: FormTagEnum.telefono,
    label: 'Teléfono',
    type: '',
    placeholder: 'Teléfono',
    formControlName: 'telefono',
    obligatorio: true,
    responsivo: true,
    validadores: [],
    clasePersonalizadaLayoutCamposPorcentaje: [ClasesCampoLayoutCamposPorcentajeFormularioEnum.campoPorcent6x],
  },
  {
    tag: FormTagEnum.captcha,
    label: 'Código de verificación',
    type: '',
    placeholder: 'Código de verificación',
    formControlName: 'captcha',
    obligatorio: true,
    validadores: [],
    clasePersonalizadaLayoutCamposPorcentaje: [ClasesCampoLayoutCamposPorcentajeFormularioEnum.campoPorcent4x],
  },
  {
    tag: FormTagEnum.checkbox,
    label: 'He leído y acepto la ',
    labelLink: {
      texto: 'Política de privacidad',
    },
    type: '',
    formControlName: 'politica_privacidad',
    obligatorio: true,
    responsivo: true,
    validadores: [],
    clasePersonalizadaLayoutCamposPorcentaje: [ClasesCampoLayoutCamposPorcentajeFormularioEnum.campoPorcent6x],
  },
  {
    tag: FormTagEnum.checkbox,
    label: 'Deseo recibir comunicaciones comerciales.',
    type: '',
    formControlName: 'comunicacionesComerciales',
    validadores: [],
    clasePersonalizadaLayoutCamposPorcentaje: [ClasesCampoLayoutCamposPorcentajeFormularioEnum.campoPorcent6x],
    responsivo: true
  },
]
